import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const WeldCommentStyled = styled(Box).attrs({
  mt: { sm: '550' },
  mb: { sm: '700' },
  px: { sm: '450' },
  pt: { sm: '450' },
  pb: { sm: '500' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    border-radius: ${theme.spacings['200']};
    background-color: ${theme.colors.grey[100]};
  `}
`;
